import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-83" data-mp="26mmbolcun3k9">
      <div className="mx-auto max-w-5xl" data-id="element-84" data-mp="22lsmlono7ips">
        <SectionHeading title="From Clinical Uncertainty to a Clearer TRT Decision Process" data-id="element-85" data-mp="22iofaiews6uw" />

        <div className="mt-9 grid gap-4 sm:gap-6 lg:grid-cols-2" data-id="element-86" data-mp="2z8xm0nq9ciu9">
          <div className="rounded-2xl border border-alert-500/25 bg-ink-800/60 p-5 sm:p-6" data-id="element-87" data-mp="2ud8lah2i4vwd">
            <h3 className="font-display text-lg font-bold uppercase tracking-[0.1em] text-alert-500 sm:text-xl" data-id="element-88" data-mp="2q9amy8l03p4d">
              Without the Master System
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-89" data-mp="1eux3dfxa5vu5">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3" data-id="element-90" data-mp="19wdd53bnlxvz">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert-500/15" data-id="element-91" data-mp="19uskxkctar1a">
                    <XIcon className="h-3.5 w-3.5 text-alert-500" aria-hidden="true" data-id="element-92" data-mp="1c4gucqc4g57t" />
                  </span>
                  <span className="text-sm leading-snug text-white/70 sm:text-base" data-id="element-93" data-mp="y4xyavwl4kbv">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-teal-400/40 bg-teal-500/5 p-5 sm:p-6" data-id="element-94" data-mp="135vi1cx8tmfh">
            <h3 className="font-display text-lg font-bold uppercase tracking-[0.1em] text-teal-300 sm:text-xl" data-id="element-95" data-mp="odjvof9c74ei">
              With the Master System
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-96" data-mp="ff7vpmmkyu9e">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3" data-id="element-97" data-mp="jf07s9b6niji">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal-400/20" data-id="element-98" data-mp="5g0ir0jrd1mt">
                    <CheckIcon className="h-3.5 w-3.5 text-teal-300" aria-hidden="true" data-id="element-99" data-mp="afmtn3c465sg" />
                  </span>
                  <span className="text-sm font-medium leading-snug text-white sm:text-base" data-id="element-100" data-mp="2c5awdmmnl8fx">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-101" data-mp="23ch50qtxmilp">
          <CtaButton label="Get the Master System of TRT™" subLabel="Instant Access · One-Time Payment · USD 27" data-id="element-102" data-mp="1yd4cpqkakjbq" />
        </div>
      </div>
    </section>;
}